import React, { Component } from 'react'
import Button from '../../atoms/Button/Button'
import PropTypes from 'prop-types'
import './Pagination.scss'

class Pagination extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            currentOffset: 0,
            activePage: 1,
            numPagesShown: 10,
            isPrevDisabled: true,
            isNextDisabled: false,
            pagesBefore: 0,
            pagesAfter: 0
        }

        this.state.pagesBefore = Math.ceil(this.state.numPagesShown / 2) - 1
        this.state.pagesAfter = this.state.numPagesShown - this.state.pagesBefore - 1
    }

    /**
     * @returns the start and end page numbers to ensure only a set number of page 
     * numbers (this.state.numPagesShown) are shows
     */
    getIndices = () => {
        const totalPages = Math.ceil(this.props.total / this.props.pageLimit)
        const pageNumber = (this.state.currentOffset / this.props.pageLimit) + 1

        let start, end
        if (totalPages <= this.state.numPagesShown) {
            start = 1
            end = totalPages 
        } else if (pageNumber <= this.state.pagesBefore) {
            start = 1
            end = this.state.numPagesShown
        } else if (pageNumber + this.state.pagesAfter > totalPages) {
            start = totalPages - this.state.numPagesShown + 1
            end = totalPages
        } else {
            start = pageNumber - this.state.pagesBefore
            end = pageNumber + this.state.pagesAfter
        }

        return { start, end }
    }

    getPageNumbers = () => {
        const pageNumbers = [];
        let { start, end } = this.getIndices();
        
        for (let i = start; i <= end; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers
    }

    renderPage = (offset) => {
        this.setState({ 
            currentOffset: offset,
            activePage: (offset / this.props.pageLimit) + 1,
            isPrevDisabled: offset === 0,
            isNextDisabled: offset + this.props.pageLimit >= this.props.total
        })

        this.props.getData(offset)
    }

    render() {
        let pages = this.getPageNumbers()

        return (
            <div id='pagination'>
            {
                pages.length > 1
                ? (
                    <div className='pagination-bar'>
                        <Button 
                            name='&laquo; prev'
                            className='page-button'
                            size='sm'
                            disabled={this.state.isPrevDisabled}
                            onClick={() => this.renderPage(this.state.currentOffset - this.props.pageLimit)} />
                        
                        {
                            pages.map(number => {
                                let offset = (number * this.props.pageLimit) - this.props.pageLimit
                                return (
                                    <Button
                                        key={number}
                                        name={number}
                                        className={(this.state.activePage === number ? 'active-button ' : 'page-button')}
                                        role='link'
                                        size='sm'
                                        disabled={(this.state.activePage === number)}
                                        onClick={() => this.renderPage(offset)} />
                                );
                            })
                        }

                        <Button 
                            name='next &raquo;'
                            className='page-button'
                            size='sm'
                            disabled={this.state.isNextDisabled}
                            onClick={() => this.renderPage(this.state.currentOffset + this.props.pageLimit)} />
                    </div>
                )
                : (
                    <></>
                )
            }
            </div>
        )
    }
}

Pagination.propTypes = {
    total: PropTypes.number.isRequired,
    pageLimit: PropTypes.number.isRequired,
    getData: PropTypes.func.isRequired
};

export default Pagination